import React, {createContext, useContext} from 'react'
// eslint-disable-next-line no-restricted-imports
import {UIUtilsEjsVariables} from '../../../../code/client/shared/scripts/UIUtilsEjsVariables'

interface UIGlobalContextProps {
    language: string
    isUserOnDiscord: boolean
    isUserOnMobileAppOrWeb: boolean
    isUserOnMobile: boolean
    isUserOnMobileWebBrowser: boolean
    isUserOnTabletApp: boolean
    isUserOnDiscordMobile: boolean
}

const UIGlobalContext = createContext<UIGlobalContextProps | undefined>(undefined)

export const useUIGlobalContext = () => {
    const context = useContext(UIGlobalContext)
    if(!context) throw new Error('UIGlobalContext not found')
    return context
}

interface UIGlobalProviderProps extends Partial<UIGlobalContextProps> {
    children: React.ReactNode
}

export const UIGlobalContextProvider = ({children, ...props}: UIGlobalProviderProps) => <UIGlobalContext.Provider value={{
    language: UIUtilsEjsVariables.language,
    isUserOnDiscord: UIUtilsEjsVariables.isUserOnDiscord,
    isUserOnMobileAppOrWeb: UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
    isUserOnMobile: UIUtilsEjsVariables.isUserOnMobile,
    isUserOnMobileWebBrowser: UIUtilsEjsVariables.isUserOnMobileWebBrowser,
    isUserOnTabletApp: UIUtilsEjsVariables.isUserOnTabletApp,
    isUserOnDiscordMobile: UIUtilsEjsVariables.isUserOnDiscordMobile,
    ...props,
}}>
    {children}
</UIGlobalContext.Provider>
